import React, { ErrorInfo } from "react"
import { captureException } from "../services/exception-logger"
import { ErrorFallbackUI } from "./ErrorFallbackUI"
import { ErrorBoundary } from "react-error-boundary"

type Props = {
  children: React.ReactNode
}

const logError = (error: Error, info: ErrorInfo) => {
  captureException(error, {
    tags: {
      errorSource: "ErrorBoundary - web",
      errorInfo: JSON.stringify(info),
    },
  })
}

export const ErrorBoundaryComponent = ({ children }: Props) => {
  return (
    <ErrorBoundary fallback={<ErrorFallbackUI />} onError={logError}>
      {children}
    </ErrorBoundary>
  )
}
